import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  openItem: ['dashboard'],
  drawerOpen: false,
  scrollTop: false,
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload;
    },
    scrollToTop(state, action) {
      state.scrollTop = action.payload;
    },
  },
});

export default menu.reducer;

export const { activeItem, openDrawer, scrollToTop } = menu.actions;
